<template>
  <sidebar-right
    @overlayClicked="outside"
    :class="[
      'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--600',
      { open: show }
    ]"
  >
    <div class="h-100 bg-white">
      <div class="card border-0">
        <!-- Card header -->
        <div
          class="card-header d-flex align-items-center chat-header-title yellow-class"
        >
          <!-- Title -->
          <!-- Title -->
          <div class="col px-0">
            <h4 class="h3 mb-0">Change Logs:</h4>
          </div>
        </div>
        <!-- Card Body -->
        <div class="card-body p-0">
          <div
            class="timeline timeline-one-side bg-white"
            data-timeline-content="axis"
            data-timeline-axis-style="dashed"
          >
            <div
              v-for="(p, i) in logs"
              :key="i"
              class="timeline-block bg-white  p-3 border border-right-0 border-left-0 border-top-0 d-flex flex-row m-0 justify-contnent-center align-items-center"
            >
              <div class="col"><user-avatar :data="{ user: p.user }" :disableEdit="true" /></div>
              <div class="timeline-content m-0 p-0 col-md-12">
                <div class="d-flex justify-content-between pt-1">
                  <div>
                    <span class="badge badge-pill align-baseline badge-info">{{
                      logType(p)
                    }}</span>
                  </div>
                  <div class="text-right">
                    <small class="text-muted"
                      ><i class="fas fa-clock mr-1" />{{ fromNow(p) }}</small
                    >
                  </div>
                </div>
                <h6 class="text-sm mt-2 mb-0 ml-1">{{ p.subject }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </sidebar-right>
</template>
<script>
import moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
import UserAvatar from "./UserAvatar.vue";
import SidebarRight from "../layout/SidebarRight.vue";
export default {
  props: ["show", "fullWidth", "project"],
  components: { UserAvatar, SidebarRight },
  name: "DetailLog",
  data() {
    return {
      logs: []
    };
  },
  watch: {
    profile(val) {
     if (
        val &&
        val.role &&
        val.role.name != "guest"
      ) {
        this.refreshRecords();
      }
    }
  },
  computed: {
    ...mapState("user", ["profile"])
  },
  async mounted() {
    this.$nextTick(() => {
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name != "guest"
      ) {
        this.refreshRecords();
      }
    });
  },

  methods: {
    ...mapActions("user", ["fetchAllLogs"]),
    fromNow(l) {
      return moment(l.created_at).fromNow();
    },
    logType(l) {
      return l && l.type && l.type.replace("_", " ");
    },
    async refreshRecords() {
      try {
        this.logs = await this.fetchAllLogs("active");
      } catch (e) {
        console.log(e);
        //this.$snack.success("Error fetching activity logs")
      }
    },

    outside() {
      this.$emit("outSideClicked");
    }
  }
};
</script>
<style scoped>
@media only screen and (max-width: 768px) {
  .chat-header-title {
    padding-top: 2rem;
  }
}
.chat-header-title {
  background: #212529;
  padding: 0.7rem 1.5rem;
  border-bottom: 5px solid #fbdf43;
  border-radius: 0;
}
.chat-header-title.green-class {
  border-bottom: 5px solid #fbdf43;
}
.chat-header-title.yellow-class {
  border-bottom: 5px solid #fbdf43;
  /* margin-top: -7px; */
}
.chat-header-title h4 {
  color: #fff;
  font-size: 24px;
  line-height: 1;
}
.header-title {
  font-size: 30px;
  font-weight: bold;
  color: #ffff;
  margin-bottom: -10px;
  margin-top: 10px;
}
.bracket {
  font-size: 30px;
  color: #fddf43;
}
.timeline-content{
  top:0;
}
</style>
